<div class="content">
  <div class="logo">
    <img
      class="name"
      src="../../../assets/images/universalbus_text_white.png"
    />

    <div class="site">universalbus.cn</div>

    <div class="line"></div>

    <div class="prompt">没时间解释了，快上车～</div>
  </div>

  <div class="spacer"></div>

  <div class="feature">
    <div class="desc">全球优质互联网服务</div>
    <div class="desc">一站式合租平台</div>

    <div class="feature-list">
      <div class="feature-item">
        <img src="../../../assets/images/feature_safe.png" />
        <div>平台安全担保 翻车必赔</div>
      </div>
      <div class="feature-item">
        <img src="../../../assets/images/feature_price.png" />
        <div>产品种类齐全 价格最低</div>
      </div>
      <div class="feature-item">
        <img src="../../../assets/images/feature_fan.png" />
        <div>自媒体粉丝 200万+</div>
      </div>
      <div class="feature-item">
        <img src="../../../assets/images/feature_service.png" />
        <div>人工客服在线 售后保障</div>
      </div>
    </div>
  </div>
</div>
